/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel } from '@/wpt-lib/pdf/useData';

const Leadership = ({
    keyPerformanceIndicatorsLeadership,
    formalLeadershipRole,
    formalLeadershipDetails,
    internalOrExternalGoalLeadership,
    areasOfContributionLeadership,
    initiativesLeadership,
}: Partial<{
    keyPerformanceIndicatorsLeadership: string;
    formalLeadershipRole: string;
    formalLeadershipDetails: string;
    internalOrExternalGoalLeadership: string;
    areasOfContributionLeadership: string;
    initiativesLeadership: string;
}>) => (
    <>
        {keyPerformanceIndicatorsLeadership && (
            <Row>
                <ValueCell label="Key Performance Indicators (KPIs)" value={keyPerformanceIndicatorsLeadership} />
            </Row>
        )}
        <Row>
            {formalLeadershipRole && (
                <ValueCell
                    label="Formal Leadership"
                    value={useLabel('formalLeadershipRole', formalLeadershipRole ?? '')}
                />
            )}
            {internalOrExternalGoalLeadership && (
                <ValueCell
                    label="Internal Or External Goal"
                    value={useLabel('internalOrExternalGoalLeadership', internalOrExternalGoalLeadership ?? '')}
                />
            )}
        </Row>
        {formalLeadershipDetails && (
            <Row>
                <ValueCell label="Detail" value={formalLeadershipDetails} />
            </Row>
        )}
        {areasOfContributionLeadership && (
            <Row>
                <ValueCell label="Areas Of Contribution To The Faculty" value={areasOfContributionLeadership} />
            </Row>
        )}
        {initiativesLeadership && (
            <Row>
                <ValueCell label="Initiatives In Support Of Faculty" value={initiativesLeadership} />
            </Row>
        )}
    </>
);

export default Leadership;
